import * as React from 'react';
import { useTheme } from '../../../theme';
import cn from 'classnames';
import { useContext } from 'react';
import { OrderCardContext } from '../OrderCard';
import { CdnIcon, CdnIconNames } from '@shared/ui/';

export interface Props {
	payloadClassName?: string;
	icon: CdnIconNames;
	type?: 'account' | 'review';
	text: React.ReactNode;
	buttons?: React.ReactNode;
	className?: string;
	iconClassName?: string;
}

const CommonItem: React.FC<Props> = props => {
	const theme = useTheme('OrderCard').CommonItem;

	const { type } = useContext(OrderCardContext);

	return (
		<div
			className={cn(theme.root, props.className, {
				[theme.account]: type === 'account',
				[theme.review]: type === 'review'
			})}
		>
			<div className={cn(theme.payload, props.payloadClassName)}>
				{props.icon && (
					<div className={theme.icon}>
						<CdnIcon icon={props.icon} className={props.iconClassName} />
					</div>
				)}

				<div className={theme.text}>{props.text}</div>
			</div>

			{props.buttons && <div className={theme.buttons}>{props.buttons}</div>}
		</div>
	);
};

export default CommonItem;
